function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import SeeWhatItsLike from "../../../components/SeeWhatItsLike/SeeWhatItsLike";
import img1 from "./images/1.png";
import img2 from "./images/2.png";
import img3 from "./images/3.png";
export default function VendorDashboardSeeWhatItsLike(props) {
  return /*#__PURE__*/React.createElement(SeeWhatItsLike, _extends({}, props, {
    "data-testid": 'vendor-dashboard-' + props['data-testid'],
    as: "textButton",
    steps: [{
      title: 'Monitor agreements',
      subtitle: 'Always seal the deal! Stay on top of sent proposals and agreement statuses.',
      image: {
        src: img1,
        width: 1246,
        height: 748
      }
    }, {
      title: 'Monitor invoices',
      subtitle: 'Keep track of invoices that require your attention or that are expected to be paid.',
      image: {
        src: img2,
        width: 1246,
        height: 748
      }
    }, {
      title: 'Monitor the health of your business',
      subtitle: 'Keep track of your cash flow and expected payouts throughout the month.',
      image: {
        src: img3,
        width: 1246,
        height: 748
      }
    }]
  }));
}